import { render, staticRenderFns } from "./ClientDetails_Invoice_Total.vue?vue&type=template&id=e915e166&"
import script from "./ClientDetails_Invoice_Total.vue?vue&type=script&lang=js&"
export * from "./ClientDetails_Invoice_Total.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports